import { useState, VFC } from 'react';

import JsonSchemaSelect, { Option } from 'dashboard/components/JsonSchemaSelect';
import { ExpressionRuleValueAll } from 'dashboard/lib/workflows';
import { JsonSchema, JsonSchemaTypes } from 'lib/json-schema';

const booleanSelect: JsonSchema = {
  type: JsonSchemaTypes.Object,
  properties: {
    true: { type: JsonSchemaTypes.Boolean },
    false: { type: JsonSchemaTypes.Boolean },
  },
};

const booleanTransformer: Record<string, string> = {
  true: 'true',
  false: 'false',
};

interface BooleanSelectProps {
  id?: string;
  hasError?: boolean;
  size?: 'sm' | 'md';
  ariaLabel?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  inputValue: string;
  setVariableValue: (value: ExpressionRuleValueAll) => void;
}

const BooleanSelect: VFC<BooleanSelectProps> = ({
  id = 'boolean-select__input',
  ariaLabel = 'Select true or false',
  autoFocus = false,
  disabled = false,
  hasError = false,
  size = 'sm',
  inputValue,
  setVariableValue,
}) => {
  const [value, setValue] = useState<string | string[]>(inputValue);

  return (
    <JsonSchemaSelect
      id={id}
      ariaLabel={ariaLabel}
      size={size}
      inputValue={value}
      jsonSchema={booleanSelect}
      allowedTypes={[JsonSchemaTypes.Boolean]}
      tokensToDisplayValue={booleanTransformer}
      autoFocus={autoFocus}
      disabled={disabled}
      hasError={hasError}
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      onFieldSelect={(option: Option) => {
        setVariableValue(option.value === 'true');
      }}
      onValueChange={setValue}
    />
  );
};

export default BooleanSelect;
